import React, {useEffect, useState} from "react";
import {wdiCore, WdiModalAppProps} from "@/components/WdiControls";
import moment from "moment";
import {FilterColumn, GridFilterForm} from "@/components/GridWidget/GridFilterForm";
import {DatePicker, Input, Popover} from "antd";
import {ColumnsType} from "antd/lib/table";
import {Enum} from "@/enums/system";
import {Invoices} from "@/services/sales/financial/invoices";
import DataStore from "@/components/GridWidget/DataStore";
import {WdiModal} from "@/components/WdiControls/WdiModalForm";
import {WdiTable} from "@/components/WdiControls/WdiTable";

const {RangePicker} = DatePicker;

export const InvoiceQueryApp: React.FC<{ realInvoiceCode?: string, realInvoiceNo?: string, invoiceId?: number } & WdiModalAppProps> = (props) => {
  const [loading, setLoading] = useState(false);
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [initialValues, setInitialValues] = useState<any>();

  const {data, realInvoiceCode, realInvoiceNo, invoiceId} = props;

  useEffect(() => {
    setInitialValues({
      purchaserTaxNo: data?.branchCompany?.taxNo,
      invoiceDate: [moment().add(-30, 'days'), moment()]
    });
  }, [data])

  useEffect(() => {
    const newDataSource = [...dataSource];
    newDataSource.forEach(item => {
      if ((item.realInvoiceCode || '') == (realInvoiceCode || '') && item.realInvoiceNo == realInvoiceNo) {
        item.invoiceId = invoiceId;
      }
    })
    setDataSource(newDataSource);
  }, [realInvoiceCode, realInvoiceNo, invoiceId])

  const getPopoverContent = (invoice?: any) => {
    return <div style={{width: 850}}>
      <WdiTable
        showPageRows={8}
        columns={[
          {title: '发票号码', width: 150, dataIndex: 'invoiceNo', ellipsis: true,},
          {title: '发票代码', width: 150, dataIndex: 'invoiceCode', ellipsis: true,},
          {title: '货物/服务名称', width: 150, dataIndex: 'commodityName', ellipsis: true,},
          {title: '含税金额', width: 100, dataIndex: 'amountInVat', ellipsis: true},
          {title: '未税金额', width: 100, dataIndex: 'amountExVat', ellipsis: true,},
          {title: '税金', dataIndex: 'tax', width: 100, ellipsis: true,},
          {
            title: '税率', dataIndex: 'taxRate', width: 80, ellipsis: true,
            render: (value: any, record: any) => {
              return wdiCore.Number.RateToString(value);
            }
          },
        ]}
        dataSource={DataStore.init(invoice?.details || [])}
        pagination={false}
      />
    </div>;
  };

  const filterColumns: FilterColumn[] = [
    {
      title: '购方税号',
      dataIndex: 'purchaserTaxNo',
      span: 4,
      require: true,
      render: () => {
        return <Input/>
      },
    },
    {
      title: '发票更新日期',
      dataIndex: 'invoiceDate',
      span: 8,
      require: true,
      render: () => {
        return <RangePicker format={'YYYY-MM-DD'} style={{width: '100%'}}/>
      }
    },
    {
      title: '销方名称',
      dataIndex: 'salesName',
      span: 4,
      require: true,
      render: () => {
        return <Input/>
      },
    }
  ];
  const columns: ColumnsType<any> = [
    {
      title: '实际发票号码',
      width: 120,
      dataIndex: 'realInvoiceNo',
      ellipsis: true,
      render: (value, record) => {
        return <Popover
          content={getPopoverContent(record)}
          trigger="click"
          placement="bottomRight"
        >
          <span style={{color: '#1296db', cursor: 'pointer'}}>{value}</span>
        </Popover>
      },
    },
    {
      title: '实际发票代码',
      width: 120,
      dataIndex: 'realInvoiceCode',
      ellipsis: true,
    },
    {
      title: '开票日期',
      width: 100,
      dataIndex: 'invoiceDate',
      ellipsis: true,
      render: (value, record) => (
        wdiCore.Date.DateToString(value)
      ),
    },
    {
      title: '销方名称',
      width: 150,
      dataIndex: 'salesName',
      ellipsis: true,
    },
    {
      title: '发票总金额',
      dataIndex: 'amountInVat',
      width: 100,
      ellipsis: true,
    },
    {
      title: '发票税金',
      width: 80,
      dataIndex: 'tax',
      ellipsis: true,
    },
    {
      title: '发票类型',
      width: 80,
      dataIndex: 'invoiceType',
      ellipsis: true,
      render: (value, record) => (
        Enum.InvoiceType.SPECIAL == value ? '专用发票' : '普通发票'
      ),
    },
    {
      title: '操作',
      width: 100,
      dataIndex: 'operater',
      ellipsis: true,
      render: (_, record) => {
        if (record.invoiceId) {
          return <></>
        } else {
          return <a onClick={() => {
            data?.showCreate(record);
          }}>创建发票</a>
        }
      },
    },
  ];

  const doSearch = (filterOptions: any) => {
    const {invoiceDate} = filterOptions;
    if (!wdiCore.Object.IsNullOrUndefined(invoiceDate)) {
      filterOptions.invoiceStartDate = moment(invoiceDate[0]).format('YYYY-MM-DD');
      filterOptions.invoiceEndDate = moment(invoiceDate[1]).format('YYYY-MM-DD');
    }
    setLoading(true)
    Invoices.queryBaiWang(filterOptions).then(responseResult => {
      setDataSource(DataStore.init(responseResult.data));
      setLoading(false)
    })
  }
  return (
    <>
      <WdiModal
        width={1000}
        title={props.title}
        visible={props.visible}
        closable={false}
        cancelButtonProps={{
          hidden: true
        }}
        okText={'关闭'}
        onOk={() => {
          props.onClose?.()
        }}
      >
        <GridFilterForm doSearch={doSearch} columns={filterColumns} initialValues={initialValues}/>
        <WdiTable
          showPageRows={10}
          columns={columns}
          size='small'
          dataSource={dataSource}
          loading={loading}
        />

      </WdiModal>
    </>
  );
}
